import ReactDOM from "react-dom";

import App from "./App";
import "./index.css";
import "./App.css";

ReactDOM.render(<App />, document.getElementById("root"));
